import { connect }          from 'react-redux';
import Locale               from '../../../locale';
import Errors               from '../../../errors';
import SuccessString        from '../../../success';
import { redeem }           from './on-the-spot-dux';
import OnTheSpot            from './on-the-spot.jsx';
import { dismissError }     from '../../../errors-dux';
import { dismissSuccess }   from '../../../success-dux';

export default connect(
    // mapStateToProps
    ( state, ownProps ) => {
      return {
            errors: Errors.getByType( state, Errors.ERROR_OTS_REDEEM ),
            busy: !!state.onTheSpotData.busy,
            success: !!state.successData.done,
            successMessage: SuccessString.getByType( state, SuccessString.SUCCESS_OTS_REDEEM ),
            userName: state.userData.userName,
            cardPlaceholder: Locale.getString( state, 'ots.form.cardPlaceholder' )
        };
    },
    // mapDispatchToProps
    {
        redeem,
        dismissError,
        dismissSuccess
    }
)( OnTheSpot );
